// highlightDirective.js
let styleAdded = false

// 添加高亮样式
function addHighlightStyle() {
  if (styleAdded) return
  
  const style = document.createElement('style')
  style.textContent = `
    .vue-highlight {
      background: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
      color: #333;
      padding: 2px 4px;
      border-radius: 4px;
      font-weight: 600;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      transition: all 0.3s ease;
    }
    .vue-highlight:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
  `
  document.head.appendChild(style)
  styleAdded = true
}

// 高亮文本函数
function highlightText(element, keyword) {
  // 先移除之前的高亮
  removeHighlights(element)
  
  if (!keyword || typeof keyword !== 'string') return
  
  // 转义关键字中的正则特殊字符
  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(escapedKeyword, 'gi')
  
  // 遍历所有文本节点
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    null,
    false
  )
  
  const nodes = []
  let node
  while (node = walker.nextNode()) {
    nodes.push(node)
  }
  
  nodes.forEach(textNode => {
    const text = textNode.textContent
    if (regex.test(text)) {
      const highlightedText = text.replace(regex, (match) => {
        return `<span class="vue-highlight">${match}</span>`
      })
      
      const span = document.createElement('span')
      span.innerHTML = highlightedText
      textNode.parentNode.replaceChild(span, textNode)
    }
  })
}

// 移除高亮
function removeHighlights(element) {
  const highlights = element.querySelectorAll('.vue-highlight')
  highlights.forEach(highlight => {
    const parent = highlight.parentNode
    parent.replaceChild(document.createTextNode(highlight.textContent), highlight)
    parent.normalize()
  })
}

// Vue 指令定义
const highlightDirective = {
  inserted: function (el, binding) {
    addHighlightStyle()
    highlightText(el, binding.value)
  },
  update: function (el, binding) {
    highlightText(el, binding.value)
  },
  unbind: function (el) {
    removeHighlights(el)
  }
}

export default highlightDirective